import * as intl from "@arcgis/core/intl";
import { useContext, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { LANGUAGES } from "../../../../data/constants";
import { isWidgetDisplayed } from "../../../../esri/widgets/expandUtils";
import { getOpsColor } from "../../../../utils/helper";

import { ConfigContext } from "../../../../utils/ConfigContext";
import SidebarDropdown from "../../../App/DesktopApp/Sidebar/UI/SidebarDropdown/SidebarDropdown";
import Dropdown, { DropdownMenu, DropdownMenuItem } from "../../../Dropdown";
import { MdTranslate } from "../../../Icons";
import { IconButton } from "../../../UI";

const LanguageDropdown = ({
  config,
  className,
  isModules,
  id,
  isMobile = false,
  ...props
}) => {
  const { setActiveLanguage } = useContext(ConfigContext);
  const { i18n } = useTranslation("common");
  const [show, setShow] = useState(false);
  const activeModule = useSelector((state) => state.activeModule);

  const hideLanguageSelection = useMemo(() => {
    return (
      !isWidgetDisplayed(config, "LanguageSwitcher") ||
      !(config.supportedLngs && config.supportedLngs.length > 1)
    );
  }, [config]);

  if (hideLanguageSelection) return null;

  const opsColor = useMemo(() => getOpsColor(config), [config]);
  const options = config.supportedLngs.map((lang) => {
    const item = LANGUAGES[lang];
    return {
      selected: i18n.language === lang,
      title: item.title,
      icon: (
        <span style={{ fontWeight: 600 }}>
          {item.displayCode.toUpperCase()}
        </span>
      ),
      onClick: () => {
        const languageConfig = {
          showModules: false,
          languageModule: activeModule,
        };
        localStorage.setItem("languageConfig", JSON.stringify(languageConfig));
        setActiveLanguage(lang);
        i18n
          .changeLanguage(lang, () => {
            if (lang === "zh-cn") {
              intl.setLocale("zh-CN");
            } else {
              intl.setLocale(lang);
            }
          })
          .then(() => {
            // window.location.reload()
          });
      },
    };
  });

  if (!isMobile) {
    return (
      <IconButton
        onClick={() => setShow((prev) => !prev)}
        style={{ position: "relative", background: "rgba(0,0,0,0.08)" }}
      >
        <MdTranslate />
        {show && <SidebarDropdown options={options} zIndex={21} />}
      </IconButton>
    );
  } else {
    return (
      <Dropdown setShow={setShow} show={show} leftOffset={0.5} top={8}>
        <IconButton>
          <MdTranslate fill="rgb(65, 65, 66)" />
        </IconButton>
        <DropdownMenu isMobile={isMobile}>
          {config.supportedLngs.map((lang) => (
            <DropdownMenuItem
              key={lang}
              selected={i18n.language === lang}
              opsColor={opsColor}
              onClick={() => {
                console.log("ckicked");

                const languageConfig = {
                  showModules: isModules,
                  languageModule: activeModule,
                };
                localStorage.setItem(
                  "languageConfig",
                  JSON.stringify(languageConfig)
                );
                i18n
                  .changeLanguage(lang, () => {
                    if (lang === "zh-cn") {
                      intl.setLocale("zh-CN");
                    } else {
                      intl.setLocale(lang);
                    }
                  })
                  .then(() => {
                    window.location.reload();
                  });
                setShow(false);
              }}
            >
              <span
                style={{
                  fontWeight: 600,
                  color: opsColor,
                }}
              >
                {LANGUAGES[lang].displayCode?.toUpperCase()}
              </span>
              <span>{LANGUAGES[lang].title}</span>
            </DropdownMenuItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    );
  }
};

export default LanguageDropdown;
